
<ng-container *ngIf="frame">
  <ul class="fpages-list fpages-total-{{frame.pages.length}}">
    <li *ngFor="let flying of frame.pages">
      <div>
        <a routerLink="/rulebook/fpage/{{flying.id}}"> {{ flying.title }}</a>
      </div>
    </li>
  </ul>
</ng-container>

<ng-container *ngIf="frame">
  <ul class="books-list books-total-{{frame.articles.length}}">
    <li *ngFor="let book of frame.articles">
      <app-book [book]="book"></app-book>
    </li>
  </ul>
</ng-container>

<ng-container>
    <ul class="fpages-list fpages-total-1">
      <li>
        <div>
          <a routerLink="/rulebook/interpretations">{{'Interpretations' | transloco}}</a>
        </div>
      </li>
    </ul>
</ng-container>
